import React, { useState, useEffect } from "react";
import "./contact.css";
import { db } from "../firebase";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    db.collection("contacts")
      .add({
        name: name,
        email: email,
        phone: phone,
        message: message,
      })
      .then(() => {
        setLoader(false);
        alert("Your message has been submitted👍");
      })
      .catch((error) => {
        alert(error.message);
        setLoader(false);
      });

    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <h2 className="gittu">Contact (24 x 7)</h2>
      <h3>+91 8770038486 </h3>
      <h3></h3>
      <br/>
      <h2 className="sona">Office-Address</h2>
      <h4>Kushalpur Chowk, Ring Road No.1, Raipur(C.G.)</h4>
      <br /><br /><br />

      <h2 className="sanju">For Any Queries</h2>

      <label>Full Name</label>
      <input
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <label>Email</label>
      <input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

     <label>Phone Number</label>
      <input
        placeholder="Phone Number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />

      <label>Message</label>
      <textarea
        placeholder="Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      ></textarea>

      <button
        type="submit"
        style={{ background: loader ? "#ccc" : " rgb(2, 2, 110)" }}
      >
        Submit
      </button>
    </form>
  );
};

export default ContactUs;